<div
    *ngIf="
        data.componentName === DialogInvokingComponents.DeleteAddress ||
        data.componentName === DialogInvokingComponents.CancelOrder ||
        data.componentName === DialogInvokingComponents.MyStructuresList ||
        data.componentName === DialogInvokingComponents.SaveDesignConfirmation ||
        data.componentName === DialogInvokingComponents.RemoveFromNotification ||
        data.componentName === DialogInvokingComponents.DuplicateStructure
    "
    class="dialog-container"
>
    <div class="top-container">
        <h2 class="delete-title">{{ data.title }}</h2>
        <button mat-icon-button class="close-button" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="delete-item-container">
        <p>{{ data.content }}</p>
    </div>
    <div class="actions-container">
        <span class="action" (click)="closeDialogPublish()">{{ data.firstBtn }}</span>
        <span>|</span>
        <span class="action" (click)="closeDialog()">{{ data.secondBtn }}</span>
    </div>
</div>

<!-- <div *ngIf="data.componentName === DialogInvokingComponents.ActiveCoupon">
    <h2 class="title" mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content class="mat-typography">
        <div class="item-container">
            <table mat-table [dataSource]="data.activeCoupon">
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                        <mat-checkbox
                            [(ngModel)]="element.selected"
                            (change)="toggleSelection(element, $event)"
                        ></mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="couponCode">
                    <th mat-header-cell *matHeaderCellDef>{{ "genericDialogBox.label.couponCode" | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.couponCode }}</td>
                </ng-container>

                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef>{{ "genericDialogBox.label.description" | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.description }}</td>
                </ng-container>

                <tr
                    mat-header-row
                    class="table-header-row"
                    *matHeaderRowDef="['select', 'couponCode', 'description']"
                ></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: ['select', 'couponCode', 'description']"
                    class="table-data-row"
                ></tr>
            </table>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="actions-container" align="end">
        <button mat-flat-button (click)="applyCoupon()" [disabled]="selectedCoupons.length === 0" class="save-btn">
            {{ data.firstBtn }}
        </button>
        <button mat-flat-button (click)="closeDialog()" class="cancel-btn">
            {{ data.secondBtn }}
        </button>
    </mat-dialog-actions>
</div> -->

<div *ngIf="data.componentName === DialogInvokingComponents.ChangeAddress">
    <div class="top-container">
        <h2 class="title" mat-dialog-title>{{ data.title }}</h2>
        <button mat-icon-button class="close-button" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="mat-typography changeAddress-content">
        <div class="address-container">
            <mat-radio-group
                aria-label="Select an option"
                class="address-radio-group"
                [(ngModel)]="data.addressId"
                (change)="onAddressChange()"
                color="primary"
            >
                <div
                    class="address-card"
                    *ngFor="let address of data.addresses"
                    [ngClass]="{
                        'selected-address-card': address['id'] === data.addressId
                    }"
                >
                    <label class="address-label">
                        <mat-radio-button class="my-radio-button" [value]="address.id">
                            <div class="address-content">
                                <div class="address-content-heading">
                                    {{ address.name }}, {{ address.pincode }}
                                    <span class="address-type">{{ address.addressType }}</span>
                                </div>

                                <p class="address-content-body">
                                    {{ address.houseNumber }}, {{ address.address }}, {{ address.city }},
                                    {{ address.state }}
                                </p>
                            </div>
                        </mat-radio-button>
                    </label>
                </div>
            </mat-radio-group>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="actions-container" align="end">
        <button mat-flat-button (click)="onAddAddress()" class="save-btn">
            {{ "genericDialogBox.button.addNewBtn" | translate }}
        </button>
    </mat-dialog-actions>
</div>

@if (data.componentName === DialogInvokingComponents.AddAddress) {
<div class="user-details-container">
    <div class="top-section">
        <p class="title" mat-dialog-title [autofocus]="true">{{ data.title }}</p>
        <button mat-icon-button class="close-button" (click)="closeDialog()" autoFocus="false">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="body-section">
        @if (data.withUserProfileDetails) {
        <app-user-details-form [mode]="'full'" [addressID]="data.addressId" [showActionButtons]="false">
        </app-user-details-form>
        } @else {
        <app-user-details-form [mode]="'recipient-only'" [addressID]="data.addressId" [showActionButtons]="false">
        </app-user-details-form>
        }
    </div>

    <div class="actions-container">
        <button
            mat-flat-button
            class="submit-btn"
            [disabled]="!isFormDataValid()"
            [mat-dialog-close]="{
                details: getAddressDetails()
            }"
        >
            <div class="text-icon-wrapper">
                <span>Save & Continue</span>
                <mat-icon svgIcon="check" class="btn-icon"></mat-icon>
            </div>
        </button>
    </div>
</div>
} @if(data.componentName === DialogInvokingComponents.ProductReview) {
<div class="review-dialog-container">
    <div class="top-container">
        <h3 class="title">{{ "genericDialogBox.approveRejectComment.title" | translate }}</h3>
        <app-button (click)="closeDialog()" [variant]="'ghost'" [buttonClass]="'circle-btn'">
            <mat-icon>close</mat-icon>
        </app-button>
    </div>

    <form [formGroup]="productReviewForm" class="review-container">
        <div class="radio-container">
            <div class="review-radio-input-container">
                <input class="radio-input" formControlName="action" type="radio" value="Approved" id="approved" />
                <label for="approved">{{ "genericDialogBox.approveRejectComment.approve" | translate }}</label>
            </div>

            <div class="review-radio-input-container">
                <input class="radio-input" formControlName="action" type="radio" value="Rejected" id="rejected" />
                <label for="rejected">{{ "genericDialogBox.approveRejectComment.reject" | translate }}</label>
            </div>
        </div>
        @if(productReviewForm.get('action')?.value === reviewStatus.Rejected) {
        <textarea
            formControlName="reason"
            id="reason"
            name="reason"
            [placeholder]="'genericDialogBox.approveRejectComment.placeholder.reason' | translate"
        ></textarea>
        }

        <div class="btn-container">
            <app-button
                [mat-dialog-close]="productReviewForm.value"
                variant="hero"
                buttonClass="explore-btn shadow-btn"
                [disabled]="productReviewForm.invalid"
            >
                {{ "genericDialogBox.button.submitBtn" | translate }}
            </app-button>
        </div>
    </form>
</div>
}

<div
    *ngIf="
        data.componentName === DialogInvokingComponents.CourierInfo ||
        data.componentName === DialogInvokingComponents.ReturnOrder ||
        data.componentName === DialogInvokingComponents.PickupScheduled ||
        data.componentName === DialogInvokingComponents.ExchangeMessage ||
        data.componentName === DialogInvokingComponents.RefundInitiated ||
        data.componentName === DialogInvokingComponents.RejectStructure
    "
>
    <div class="courier-information">
        <h2 class="title" mat-dialog-title>{{ data.title }}:</h2>
        <mat-dialog-content class="mat-typography">
            <p *ngIf="data.content">{{ data.content }}</p>
            <br />
            <form [formGroup]="courierForm">
                <div class="item-container" *ngFor="let input of data.inputs">
                    <mat-form-field appearance="outline" class="example-full-width dense-3">
                        <input
                            matInput
                            *ngIf="input.type !== 'date' && input.type !== 'time'"
                            [formControlName]="input.controlName"
                            [placeholder]="input.placeholder"
                            [value]="input.value"
                            [type]="input.type"
                        />

                        <input
                            matInput
                            *ngIf="input.type === 'time'"
                            [formControlName]="input.controlName"
                            [ngxTimepicker]="toggleTimepicker"
                            [disableClick]="true"
                            readonly
                            [placeholder]="input.placeholder"
                        />
                        <mat-icon matSuffix *ngIf="input.type === 'time'" (click)="toggleTimepicker.open()"
                            >schedule</mat-icon
                        >
                        <ngx-material-timepicker #toggleTimepicker></ngx-material-timepicker>

                        <input
                            matInput
                            *ngIf="input.type === 'date'"
                            [formControlName]="input.controlName"
                            [placeholder]="input.placeholder"
                            [matDatepicker]="picker"
                            [value]="input.value"
                            [min]="todayDate"
                            [disabled]="true"
                            readonly
                        />
                        <mat-datepicker-toggle
                            *ngIf="input.type === 'date'"
                            matSuffix
                            [for]="picker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>
            </form>
        </mat-dialog-content>
        <mat-dialog-actions class="actions-container" align="end">
            <button
                mat-flat-button
                [mat-dialog-close]="true"
                class="save-btn"
                (click)="saveCourierInfo()"
                [disabled]="!this.courierForm.valid"
            >
                {{ data.firstBtn }}
            </button>
            <button mat-flat-button (click)="closeDialog()" class="cancel-btn" *ngIf="data.secondBtn">
                {{ data.secondBtn }}
            </button>
        </mat-dialog-actions>
    </div>
</div>

<div *ngIf="data.componentName === DialogInvokingComponents.ReturnOrderCod">
    <div class="courier-information">
        <h2 class="title" mat-dialog-title>{{ data.title }}</h2>
        <mat-dialog-content class="mat-typography">
            <p *ngIf="data.content">{{ data.content }}</p>
            <br />
            <form [formGroup]="returnOrderForm">
                <div class="item-container">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="reason" placeholder="Reason for Returning" type="text" />
                    </mat-form-field>
                </div>
                <div>
                    <mat-error
                        class="text-red"
                        *ngIf="
                            returnOrderForm.get('reason')?.hasError('required') &&
                            returnOrderForm.get('reason')?.touched
                        "
                    >
                        {{ "genericDialogBox.label.return" | translate }}
                        {{ "genericDialogBox.invalidMessage.mandatory" | translate }}
                    </mat-error>
                </div>
                <p>{{ data.content2 }}</p>

                <div>
                    <div class="radio-group">
                        <mat-radio-group formControlName="refundOption">
                            <mat-radio-button value="bankDetails">{{
                                "genericDialogBox.label.bankDetails" | translate
                            }}</mat-radio-button>
                            <mat-radio-button value="upi">{{
                                "genericDialogBox.label.upiId" | translate
                            }}</mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <!-- Bank Details Section -->
                    <div
                        *ngIf="returnOrderForm.get('refundOption')?.value === 'bankDetails'"
                        class="boundary"
                        formGroupName="bankDetails"
                    >
                        <div class="item-container">
                            <mat-form-field class="example-full-width">
                                <input
                                    matInput
                                    formControlName="accountHolderName"
                                    placeholder="Insert account holder name"
                                    type="text"
                                />
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-error
                                class="text-red"
                                *ngIf="
                                    returnOrderForm
                                        .get('bankDetails')
                                        ?.get('accountHolderName')
                                        ?.hasError('required') &&
                                    returnOrderForm.get('bankDetails')?.get('accountHolderName')?.touched
                                "
                            >
                                {{ "genericDialogBox.label.accountHolderName" | translate }}
                                {{ "genericDialogBox.invalidMessage.mandatory" | translate }}
                            </mat-error>
                            <mat-error
                                class="text-red"
                                *ngIf="
                                    returnOrderForm
                                        .get('bankDetails')
                                        ?.get('accountHolderName')
                                        ?.hasError('invalidAccountHolderName') &&
                                    returnOrderForm.get('bankDetails')?.get('accountHolderName')?.touched
                                "
                            >
                                {{ "genericDialogBox.invalidMessage.accountNameInvalid" | translate }}
                            </mat-error>
                        </div>

                        <div class="item-container">
                            <mat-form-field class="example-full-width">
                                <input
                                    matInput
                                    formControlName="accountNumber"
                                    placeholder="Insert bank account number"
                                />
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-error
                                class="text-red"
                                *ngIf="
                                    returnOrderForm.get('bankDetails')?.get('accountNumber')?.hasError('required') &&
                                    returnOrderForm.get('bankDetails')?.get('accountNumber')?.touched
                                "
                            >
                                {{ "genericDialogBox.label.accountNo" | translate }}
                                {{ "genericDialogBox.invalidMessage.mandatory" | translate }}
                            </mat-error>
                            <mat-error
                                class="text-red"
                                *ngIf="
                                    returnOrderForm
                                        .get('bankDetails')
                                        ?.get('accountNumber')
                                        ?.hasError('invalidAccountNumber') &&
                                    returnOrderForm.get('bankDetails')?.get('accountNumber')?.touched
                                "
                            >
                                {{ "genericDialogBox.invalidMessage.accountnoInvalid" | translate }}
                            </mat-error>
                        </div>

                        <div class="item-container">
                            <mat-form-field class="example-full-width">
                                <input matInput formControlName="ifscCode" placeholder="Insert IFSC code" type="text" />
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-error
                                class="text-red"
                                *ngIf="
                                    returnOrderForm.get('bankDetails')?.get('ifscCode')?.hasError('required') &&
                                    returnOrderForm.get('bankDetails')?.get('ifscCode')?.touched
                                "
                            >
                                {{ "genericDialogBox.label.ifscCode" | translate }}
                                {{ "genericDialogBox.invalidMessage.mandatory" | translate }}
                            </mat-error>
                            <mat-error
                                class="text-red"
                                *ngIf="
                                    returnOrderForm.get('bankDetails')?.get('ifscCode')?.hasError('invalidIfsc') &&
                                    returnOrderForm.get('bankDetails')?.get('ifscCode')?.touched
                                "
                            >
                                {{ "genericDialogBox.invalidMessage.ifscInvalid" | translate }}
                            </mat-error>
                        </div>
                    </div>

                    <!-- UPI Section -->
                    <div
                        *ngIf="returnOrderForm.get('refundOption')?.value === 'upi'"
                        class="boundary"
                        formGroupName="upi"
                    >
                        <div class="item-container">
                            <mat-form-field class="example-full-width">
                                <input matInput formControlName="upiId" placeholder="Insert UPI" type="email" />
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-error
                                class="text-red"
                                *ngIf="returnOrderForm.get('upi')?.get('upiId')?.hasError('invalidUPI')"
                            >
                                {{ "genericDialogBox.invalidMessage.upiIdInvalid" | translate }}
                            </mat-error>
                        </div>
                    </div>
                </div>
            </form>
        </mat-dialog-content>
        <mat-dialog-actions class="actions-container" align="end">
            <button
                mat-flat-button
                [mat-dialog-close]="true"
                class="save-btn"
                (click)="returnOrderData()"
                [disabled]="!this.returnOrderForm.valid"
            >
                {{ data.firstBtn }}
            </button>
            <button mat-flat-button (click)="closeDialog()" class="cancel-btn" *ngIf="data.secondBtn">
                {{ data.secondBtn }}
            </button>
        </mat-dialog-actions>
    </div>
</div>

<div
    *ngIf="
        data.componentName === DialogInvokingComponents.ImageSlider ||
        data.componentName === DialogInvokingComponents.PreviewImage
    "
>
    <mat-dialog-content class="swiper-image-dialog-content">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" *ngFor="let img of data.imageSlider">
                    <img [src]="img.image" alt="Slide image" />
                </div>
            </div>
            <div class="swiper-button-next" (click)="goToNextSlide()"></div>
            <div class="swiper-button-prev" (click)="goToPrevSlide()"></div>
        </div>
        <div class="image-container" *ngIf="data.image">
            <img [src]="data.image" alt="Preview" />
        </div>
    </mat-dialog-content>
</div>

@if(data.componentName === DialogInvokingComponents.StructureDetails) {
<div class="structure-detials-container">
    <div class="top-container">
        <div class="title-container">
            <p class="title font-poppins">{{ data.title }}</p>
            <p>{{ data.subtitle }}</p>
        </div>

        <button mat-icon-button class="close-button icon-button-overlay-remove" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="body-container">
        <form [formGroup]="saveStructureForm">
            <div class="input-section">
                <label for="structureName" class="label font-poppins"
                    >{{ "genericDialogBox.label.structureName" | translate }}* :</label
                >
                <mat-form-field appearance="outline" class="input-form input-border-radius dense-3">
                    <input
                        id="structureName"
                        type="text"
                        matInput
                        formControlName="structureName"
                        placeholder="Give your structure a name"
                    />
                    <!-- Required Error -->
                    <mat-error *ngIf="saveStructureForm.get('structureName')?.hasError('required')">
                        {{ "genericDialogBox.label.structureName" | translate }}
                        {{ "genericDialogBox.invalidMessage.mandatory" | translate }}
                    </mat-error>

                    <!-- Leading Spaces Error -->
                    <mat-error
                        *ngIf="
                            !saveStructureForm.get('structureName')?.hasError('required') &&
                            saveStructureForm.get('structureName')?.hasError('leadingSpaces')
                        "
                    >
                        {{ "genericDialogBox.label.structureName" | translate }}
                        {{ "genericDialogBox.invalidMessage.whiteSpaceInvalid" | translate }}
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="input-section">
                <label for="structureDescription" class="label font-poppins"
                    >{{ "genericDialogBox.label.description" | translate }}* :</label
                >
                <mat-form-field appearance="outline" class="input-form input-border-radius dense-3">
                    <textarea
                        id="structureDescription"
                        rows="4"
                        matInput
                        formControlName="structureDescription"
                        placeholder="Brief description about the structure"
                    ></textarea>
                    <mat-error *ngIf="saveStructureForm.get('structureDescription')?.hasError('required')">
                        {{ "genericDialogBox.label.description" | translate }}
                        {{ "genericDialogBox.invalidMessage.mandatory" | translate }}
                    </mat-error>

                    <!-- Leading Spaces Error -->
                    <mat-error
                        *ngIf="
                            !saveStructureForm.get('structureDescription')?.hasError('required') &&
                            saveStructureForm.get('structureDescription')?.hasError('leadingSpaces')
                        "
                    >
                        {{ "genericDialogBox.label.description" | translate }}
                        {{ "genericDialogBox.invalidMessage.whiteSpaceInvalid" | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </form>
    </div>

    <div class="bottom-container">
        <button mat-stroked-button class="cancel-btn" *ngIf="data.secondBtn" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
            <span>{{ data.secondBtn }}</span>
        </button>

        <button
            mat-stroked-button
            class="confirm-btn"
            [disabled]="saveStructureForm.invalid"
            (click)="confirmationDialog()"
        >
            <mat-icon [svgIcon]="data.firstBtn === 'Save' ? 'tick' : 'publish'"></mat-icon>
            <span>{{ data.firstBtn }}</span>
        </button>
    </div>
</div>
}

<!-- my structure properties  -->
<div *ngIf="data.componentName === DialogInvokingComponents.MyStructuresListProperties">
    <h2 class="title" mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content class="mat-typography">
        <form [formGroup]="myStructureListForm">
            <!--  Structure Name  -->
            <div>
                <label for="description"
                    >{{ "genericDialogBox.label.name" | translate }}:<span class="required"> *</span></label
                >
                <input type="text" id="description" formControlName="myStructureName" required autocomplete="off" />
            </div>
            <!-- Structure Description  -->
            <div>
                <label>{{ "genericDialogBox.label.description" | translate }}:</label>
                <textarea formControlName="myStructureDescription"></textarea>
            </div>
            <!-- Status  -->
            <div>
                <label>{{ "genericDialogBox.label.status" | translate }}:</label>
                <div>
                    <mat-select formControlName="status">
                        <mat-option
                            *ngFor="let status of myStructureStatus"
                            [value]="status.value"
                            [disabled]="disableStatus(status.value)"
                            >{{ status.name }}</mat-option
                        >
                    </mat-select>
                </div>
            </div>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions class="actions-container" align="end">
        <button
            mat-flat-button
            (click)="updateStructureData()"
            [disabled]="myStructureListForm.invalid || isStatusDisabled()"
            class="save-btn"
        >
            {{ data.firstBtn }}
        </button>
        <button mat-flat-button (click)="closeDialog()" *ngIf="data.secondBtn" class="cancel-btn">
            {{ data.secondBtn }}
        </button>
    </mat-dialog-actions>
</div>

<div *ngIf="data.componentName === DialogInvokingComponents.DeleteAdvertisement" class="container">
    <div class="top-container">
        <h2 class="title" mat-dialog-title>{{ data.title }}</h2>
        <button mat-icon-button *ngIf="data.image" class="close-button" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="mat-typography">
        <div class="banner-item-container">
            <p>{{ data.content }}</p>
            <div class="banner-image-container" *ngIf="data.image">
                <div class="banner-image">
                    <img [src]="data.image" alt="Product Image" *ngIf="data.image; else noImage" />

                    <ng-template #noImage>
                        <div class="banner-image-placeholder"></div>
                    </ng-template>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="actions-container" align="end">
        <button mat-flat-button [mat-dialog-close]="true" class="save-btn">
            {{ data.firstBtn }}
        </button>
        <button mat-flat-button (click)="closeDialog()" *ngIf="data.secondBtn" class="cancel-btn">
            {{ data.secondBtn }}
        </button>
    </mat-dialog-actions>
</div>

@if (data.componentName === DialogInvokingComponents.EmailMessage) {
<div class="email-message-container">
    <div class="top-section">
        <div class="title-container">
            <span class="title font-poppins">{{ data.title }}</span>
        </div>

        <button mat-icon-button class="close-button" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="message-container">
        <div [innerHTML]="data.message"></div>
    </div>

    <div class="action-container">
        <button mat-flat-button class="btn-primary-gradient" (click)="closeDialog()">
            {{ "genericDialogBox.button.closeBtn" | translate }}
        </button>
    </div>
</div>
} @if(data.componentName === DialogInvokingComponents.ColorCustomization) {
<div class="color-customization-container">
    <div class="top-container">
        <div class="title-container">
            <p class="title font-poppins">Choose Option</p>
            <p>Select how the change should apply to your block</p>
        </div>

        <button mat-icon-button class="close-button icon-button-overlay-remove" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="body-content">
        <mat-radio-group class="radio-group" [(ngModel)]="selectedOption">
            <label class="radio-card" [class.selected]="selectedOption === 'single'">
                <div class="card-left">
                    <div class="box"></div>
                    <div class="text-content">
                        <p class="title">Single Face</p>
                        <p class="subtitle">Apply to only one side of the block</p>
                    </div>
                </div>

                <div class="separator"></div>

                <mat-radio-button value="singleFace">Select this option</mat-radio-button>
            </label>

            <label class="radio-card" [class.selected]="selectedOption === 'full'">
                <div class="card-left">
                    <div class="box"></div>
                    <div class="text-content">
                        <p class="title font-poppins">Full Face</p>
                        <p class="subtitle">Apply to all sides of the block</p>
                    </div>
                </div>

                <div class="separator"></div>

                <mat-radio-button value="fullFaces">Select this option</mat-radio-button>
            </label>
        </mat-radio-group>

        <div class="tip-container">
            <span class="icon-container">
                <mat-icon svgIcon="tip"></mat-icon>
            </span>

            <div class="tip-text-container">
                <p class="tip-title font-poppins">Pro tip</p>
                <p class="tip-subtitle">
                    Full Face applies color to every side instantly, saving you time on multi-face designs.
                </p>
            </div>
        </div>
    </div>

    <div class="actions-container">
        <button mat-stroked-button class="cancel-btn" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
            <span>Cancel</span>
        </button>

        <button mat-stroked-button class="confirm-btn" [mat-dialog-close]="selectedOption">
            <mat-icon svgIcon="tick"></mat-icon>
            <span>Confirm choice</span>
        </button>
    </div>
</div>
} @if (data.componentName === DialogInvokingComponents.popUP360) {
<div class="view360-container">
    <div class="title-container">
        <p class="title font-poppins">360° Gallery</p>
        <button mat-icon-button class="close-button icon-button-overlay-remove" (click)="closeDialog()">
            <mat-icon class="close-icon">close</mat-icon>
        </button>
    </div>

    <div class="body-content">
        <app-viewer360 [glbURL]="data.glbUrl"></app-viewer360>
    </div>

    <div class="drag-spin-container">
        <div class="drag-to-spin">
            <mat-icon class="drag-icon">touch_app</mat-icon>
            <span>Drag to Spin</span>
        </div>
    </div>

    <div class="bottom-container">
        <span class="share-icon-container" (click)="sharePage()">
            <mat-icon svgIcon="share" class="share-icon"></mat-icon>
        </span>
        <button mat-stroked-button class="view-product-btn font-poppins" (click)="closeDialog()">
            View Product Details
        </button>
    </div>
</div>
} @if(data.componentName === DialogInvokingComponents.OnBoarding) {
<div class="onboarding-container">
    <div class="top-section">
        <div class="title-container">
            <span class="title font-poppins">{{ data.title }}</span>
            <span class="subtitle">{{ data.subtitle }}</span>
        </div>

        <button mat-icon-button class="close-button" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    @if (hasCompletedTour) {
    <div class="body-section">
        <span class="quick-topics font-poppins">Quick Topics</span>
        <div class="guide-container">
            @for (step of filteredSteps; track $index) {
            <div class="guide-item" (click)="onStepClicked(step.step)">
                <div class="left-section">
                    <span class="icon-container">
                        <mat-icon>{{ step.icon }}</mat-icon>
                    </span>

                    <span class="label font-poppins">{{ step.label }}</span>
                </div>

                <div class="right-section">
                    <mat-icon>chevron_right</mat-icon>
                </div>
            </div>
            }
        </div>
    </div>
    } @else {
    <div class="content-section">
        <p>{{ data.content }}</p>
    </div>
    }

    <div class="bottom-section">
        @if (data.firstBtn) {
        <button mat-stroked-button class="close-guide-btn" [mat-dialog-close]="true" class="start-guide-btn">
            {{ data.firstBtn }}
        </button>
        } @if (data.secondBtn) {
        <button mat-stroked-button class="close-guide-btn" (click)="closeDialog()">{{ data.secondBtn }}</button>
        }
    </div>
</div>
} @if (data.componentName === DialogInvokingComponents.GetCountDialog) {
<div class="get-count-container">
    <div class="top-section">
        <div class="title-container">
            <span class="title font-poppins">Count Information</span>
            <span class="subtitle">Overview of blocks used in your design</span>
        </div>

        <button mat-icon-button class="close-button" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="bottom-section">
        @if (data.outputPattern) {
        <div class="ouput-pattern-container">
            @for (item of data.outputPattern; let i = $index; track i) {
            <div class="item-container">
                <div class="icon-name-section">
                    <span class="icon-container" [class]="'product-image-gradient' + ((i % 3) + 1)">
                        <mat-icon svgIcon="structure"></mat-icon>
                    </span>

                    <span class="name font-poppins">{{ item.name }}</span>
                </div>

                <div class="face-section">
                    <span class="face-title">Face Pattern</span>
                    <span class="face-pattern">{{ item.facePattern }}</span>
                </div>

                <div class="color-section">
                    <span class="color-title">Colors</span>
                    <div class="color-container">
                        @for (color of getFaceColors(item.color); track $index) {
                        <span class="color-item-container">
                            <span class="color-item" [ngStyle]="{ 'background-color': color.value }"> </span>
                            <span class="color-name">{{ color.key }}</span>
                        </span>
                        }
                    </div>
                </div>

                <div class="count-section">
                    <span class="count font-poppins">
                        {{ item.count }}
                    </span>
                </div>

                <div class="conection-section">
                    <span class="connection-title">Connections</span>
                    <div class="connection-container">
                        @for (connection of item.connectionData; track $index) {
                        <span
                            class="connection-item"
                            [ngClass]="{
                                'bold-text':
                                    connection.connectionType === 'Node' || connection.connectionType === 'Hole'
                            }"
                        >
                            {{ connection.face }} --- {{ connection.connectionType }}
                        </span>
                        }
                    </div>
                </div>
            </div>
            }
        </div>
        } @else {
        <mat-progress-spinner class="example-margin" color="warn" mode="indeterminate" value="100">
        </mat-progress-spinner>
        }
    </div>
</div>
}

<div class="gif-dialog-container" *ngIf="data.componentName === DialogInvokingComponents.GifShow">
    <div class="gif-wrapper">
        <img [src]="data.image" alt="{{ data.title }}" class="dialog-gif" />
    </div>

    <div class="actions-container" align="end">
        <button mat-flat-button [mat-dialog-close]="true" class="save-btn" *ngIf="data.firstBtn">
            {{ data.firstBtn }}
        </button>
        <button mat-flat-button mat-dialog-close *ngIf="data.secondBtn" class="close-btn">
            {{ data.secondBtn }}
        </button>
    </div>
</div>

@if (data.componentName === DialogInvokingComponents.ProductDetailPage) {
<div class="shape-details-container">
    <div class="top-container">
        <div class="title-container">
            <p class="title font-poppins">Shape Details</p>
            <p>Breakdown of blocks used in your design</p>
        </div>

        <button mat-icon-button class="close-button icon-button-overlay-remove" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="body-content">
        <div class="total-blocks-container">
            <div class="section">
                <span class="left-section">
                    <p class="title">Total Shapes</p>
                    <p class="count font-poppins">{{ dataSource.length }}</p>
                </span>

                <span class="right-section total-shape">
                    <mat-icon svgIcon="grandtotal"></mat-icon>
                </span>
            </div>

            <div class="section">
                <span class="left-section">
                    <p class="title">Total Blocks</p>
                    <p class="count font-poppins">{{ data.value }}</p>
                </span>

                <span class="right-section block-shape">
                    <mat-icon svgIcon="structure"></mat-icon>
                </span>
            </div>

            <div class="section">
                <span class="left-section">
                    <p class="title">Most Used</p>
                    <p class="count font-poppins">{{ getShapeWithMaxCount(dataSource) }}</p>
                </span>

                <span class="right-section most-used">
                    <mat-icon svgIcon="mostused"></mat-icon>
                </span>
            </div>
        </div>

        <div class="shape-list">
            <p class="title font-poppins">Shape Inventory</p>

            <div class="shape-container">
                @for (item of dataSource; track $index) {
                <div class="shape-item">
                    <div class="left-section">
                        <span class="shape-info">
                            <span class="shape-name font-poppins">{{ item.name }}</span>
                            <span class="shape-text">Standard block</span>
                        </span>
                    </div>

                    <div class="right-section">
                        <span class="count-container">
                            <span class="count font-poppins">{{ item.count }}</span>
                        </span>
                        <span class="count-text">Blocks used</span>
                    </div>
                </div>
                }
            </div>
        </div>

        <div class="grand-total-container">
            <div class="left-container">
                <div class="count-container">
                    <p class="count-title">Grand Total</p>
                    <p class="count-value font-poppins">{{ data.value }}</p>
                </div>
            </div>

            <div class="right-container">
                <span class="count-title">Total Blocks</span>
                <span class="count-subtitle">in this design</span>
            </div>
        </div>
    </div>

    <div class="actions-container">
        <button mat-stroked-button class="cancel-btn" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
            <span>Close</span>
        </button>

        <button mat-stroked-button class="confirm-btn" [mat-dialog-close]="selectedOption" [mat-dialog-close]="true">
            <mat-icon>visibility</mat-icon>
            <span>View in Canvas</span>
        </button>
    </div>
</div>
} @if (data.componentName === DialogInvokingComponents.LoadMyStructures) {
<div class="load-structure-container">
    <div class="top-section">
        <div class="title-container">
            <span class="title font-poppins">{{ data.title }}</span>
            <span class="subtitle">{{ data.subtitle }}</span>
        </div>

        <button mat-icon-button class="close-button" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="search-container">
        <app-search-bar
            [placeholder]="'genericDialogBox.placeHolder.searchStructure' | translate"
            [initialValue]="searchTerm"
            [debounceTime]="500"
            (search)="searchStructures($event)"
            [suffixCloseIcon]="'close'"
            [suffixSearchIcon]="'search'"
        >
        </app-search-bar>
    </div>

    <div class="body-section">
        <div class="loading-overlay" *ngIf="isLoading">
            <mat-spinner diameter="60"></mat-spinner>
        </div>

        @if(structures.count > 0) {
        <div class="structure-list">
            @for (structure of structures.rows; track structure.id) {
            <div class="structure-item" (click)="selectStructure(structure.id)">
                <div class="structure-avatar">
                    <mat-icon>description</mat-icon>
                </div>

                <div class="structure-content">
                    <div class="structure-header">
                        <span class="structure-name font-poppins">
                            {{ structure.structureName }}
                        </span>
                        <span
                            class="structure-status"
                            [ngClass]="'status-' + structure.status!.toLowerCase()"
                            [ngClass]="{
                                saved: structure.status === StructureStatus.Saved,
                                published: structure.status === StructureStatus.Published,
                                approved: structure.status === StructureStatus.Approved,
                                rejected: structure.status === StructureStatus.Rejected
                            }"
                        >
                            {{ structure.status }}
                        </span>
                    </div>

                    <div class="structure-dates">
                        <div class="created-date">
                            <mat-icon class="calendar-icon">calendar_today</mat-icon>
                            <span class="date-label">{{ "genericDialogBox.loadStructure.created" | translate }}: </span>
                            {{ structure.createdAt | date: "dd/MM/yy, h:mm a" }}
                        </div>

                        <div class="updated-date">
                            <mat-icon class="clock-icon">access_time</mat-icon>
                            <span class="date-label">{{ "genericDialogBox.loadStructure.updated" | translate }}: </span>
                            {{ structure.updatedAt | date: "dd/MM/yy, h:mm a" }}
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
        } @if (!isLoading && structures.count === 0) {
        <div class="no-results">
            <mat-icon>search_off</mat-icon>
            <p>{{ "genericDialogBox.noData.noStructureFound" | translate }}</p>
        </div>
        }
    </div>

    <div class="bottom-section">
        <mat-paginator
            [length]="pagination.totalItems"
            [pageSize]="pagination.pageSize"
            [pageIndex]="pagination.currentPage"
            (page)="changePage($event.pageIndex)"
        >
        </mat-paginator>
    </div>
</div>
}

<div *ngIf="data.componentName === DialogInvokingComponents.ConfirmationCurrentStructure" class="dialog-container">
    <div class="top-container">
        <h2 class="delete-title">{{ data.title }}</h2>
        <button mat-icon-button class="close-button" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="delete-item-container">
        <p>{{ data.content }}</p>
    </div>
    <div class="actions-container">
        <span class="action" [mat-dialog-close]="buttonData.Replace">{{ data.firstBtn }}</span>
        <span>|</span>
        <span class="action" [mat-dialog-close]="buttonData.Save" *ngIf="data.secondBtn">{{ data.secondBtn }}</span>
    </div>
</div>

<form class="payment-container" *ngIf="data.componentName === DialogInvokingComponents.PaymentDialog">
    <div class="payment-header-content">
        <span class="payment-header font-poppins">{{ "genericDialogBox.payment.heading" | translate }}</span>
        <mat-icon class="payment-close-icon" (click)="closeDialog()">close</mat-icon>
    </div>
    <div class="payment-middle-content">
        <mat-radio-group class="payment-option" [(ngModel)]="selectedPayment" name="paymentMethod">
            <mat-radio-button
                [value]="PaymentMethod.CashOnDelivery"
                [ngClass]="{ 'active-option': selectedPayment === PaymentMethod.CashOnDelivery }"
                class="option"
                [disabled]="!isUserloggedIn"
            >
                <div class="payment-option-container">
                    <span class="payment-icon-container">
                        <mat-icon svgIcon="cod" class="payment-icon"></mat-icon>
                    </span>
                    <span class="payment-option-text">
                        {{ "genericDialogBox.payment.option.cod" | translate }}
                    </span>
                </div>
            </mat-radio-button>
            <mat-radio-button
                [value]="PaymentMethod.OnlinePayment"
                [ngClass]="{ 'active-option': selectedPayment === PaymentMethod.OnlinePayment }"
                class="option"
            >
                <div class="payment-option-container">
                    <span class="payment-icon-container">
                        <mat-icon svgIcon="onlinepay" class="payment-icon"></mat-icon>
                    </span>
                    <span class="payment-option-text">
                        {{ "genericDialogBox.payment.option.online" | translate }}
                    </span>
                </div>
            </mat-radio-button>
        </mat-radio-group>

        @if (data.totalCoinBalance !== 0) {
        <mat-checkbox
            [(ngModel)]="isCoinUsed"
            class="payment-checkbox check-box-overide-blue"
            (change)="onCoinToggle()"
            name="isCoinUsed"
            >{{ "genericDialogBox.payment.reward" | translate: { coins: data.totalCoinBalance } }}</mat-checkbox
        >
        } @if (!isUserloggedIn) {
        <div class="cod-warning">
            <span class="warning-icon">i</span><b>Note:</b> Cash on Delivery is accessible only after logging in!
        </div>
        }
        <div class="payment-button-container">
            <button class="payment-btn" mat-stroked-button [mat-dialog-close]="{ paymentOption: selectedPayment }">
                {{ "checkout.button.payNowBtn" | translate }}
            </button>
        </div>
    </div>
</form>

<div class="help-container" *ngIf="data.componentName === DialogInvokingComponents.HelpMessage">
    <div class="help-close-icon">
        <mat-icon class="payment-close-icon" (click)="closeDialog()">close</mat-icon>
    </div>

    <div class="help-heading-content">
        <p class="help-heading">{{ "genericDialogBox.help.title" | translate }}</p>
    </div>

    <div class="help-query-input-container">
        <input
            class="help-query-input"
            [(ngModel)]="helpQuery"
            name="helpQuery"
            type="text"
            autocomplete="off"
            placeholder="{{ 'genericDialogBox.help.placeHolder.message' | translate }}"
        />
    </div>

    <div class="help-button-container">
        <button
            class="save-btn"
            [disabled]="!helpQuery || !helpQuery.trim()"
            [mat-dialog-close]="{ helpQuery: helpQuery }"
            mat-flat-button
        >
            {{ "genericDialogBox.help.button.continueBtn" | translate }}
        </button>
    </div>
</div>

<div class="coupon-container" *ngIf="data.componentName === DialogInvokingComponents.CouponDialog">
    <div class="coupon-heading">
        <span>Coupons:</span>
        <span (click)="closeDialog()"><mat-icon class="payment-close-icon">close</mat-icon></span>
    </div>

    <div class="payment-bottom-coupon-section" *ngIf="data.availableCoupons.length; else noCoupon">
        <div class="coupon-wrapper" *ngFor="let coupon of data.availableCoupons">
            <div class="triangle"></div>
            <div class="coupon-content">
                <div class="coupon-text-container">
                    <p>{{ coupon.description }}</p>
                    <p>{{ "genericDialogBox.coupon.code" | translate }}: {{ coupon.couponCode }}</p>
                </div>
                <div class="copy-icon-container">
                    <mat-icon (click)="copyToClipboard(coupon.couponCode)">content_copy</mat-icon>
                </div>
            </div>
        </div>
    </div>

    <ng-template #noCoupon>
        <div class="no-coupon-container">
            <p class="no-coupon-heading">{{ "genericDialogBox.coupon.couponNotFound" | translate }}</p>
            <p class="second-text">{{ "genericDialogBox.coupon.noCouponAvaialble" | translate }}</p>
        </div>
    </ng-template>
</div>

<!-- cart dialog -->
<div
    class="cart-container font-inter"
    *ngIf="
        data.componentName === DialogInvokingComponents.RemoveFromWishlist ||
        data.componentName === DialogInvokingComponents.RemoveFromCart ||
        data.componentName === DialogInvokingComponents.UnavailableProducts
    "
>
    <div class="cart-content">
        @if (data.image) {
        <div class="image-container">
            <img [src]="data.image" class="cart-image" alt="Product Image" />
        </div>
        }

        <div class="body">
            <div class="title-close-container">
                <p class="title font-poppins">{{ data.title }}</p>
                <mat-icon class="close-icon" (click)="closeDialog()">close</mat-icon>
            </div>
            <p class="content">{{ data.content }}</p>
        </div>
    </div>

    <div class="actions-container">
        <span class="move-action" [mat-dialog-close]="'move'">{{ data.secondBtn }}</span>
        <span *ngIf="data.secondBtn">|</span>
        <span class="remove-action" [mat-dialog-close]="'remove'">{{ data.firstBtn }}</span>
    </div>
</div>

<div class="chat-container" *ngIf="data.componentName === DialogInvokingComponents.ChatDialog">
    <div class="title-container">
        <p class="title">Chat</p>
        <app-button (click)="closeDialog()" [variant]="'ghost'" [buttonClass]="'circle-btn'">
            <mat-icon>close</mat-icon>
        </app-button>
    </div>

    <div class="chat-messages" #messageContainer>
        <div class="chat-message" *ngFor="let message of messages" [ngClass]="getMessageClass(message)">
            <div class="bubble">
                <p>{{ message.body }}</p>
                <span>{{ message.createdAt | date: "shortTime" }}</span>
            </div>
        </div>
    </div>
</div>
